import { History } from 'history';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import {
    applyMiddleware,
    combineReducers,
    compose,
    createStore,
    GenericStoreEnhancer,
    ReducersMapObject,
    Store,
    StoreEnhancerStoreCreator
} from 'redux';
import thunk from 'redux-thunk';
import { ApplicationState } from './data/applicationStates';
import { reducers } from './data/rootReducers';

export default function configureStore(history: History, initialState?: ApplicationState) {
    // Build middleware. These are functions that can process the actions before they reach the store.
    // tslint:disable-next-line
    const windowIfDefined = typeof window === 'undefined' ? null : (window as any);

    // If devTools is installed, connect to it
    const devToolsExtension =
        windowIfDefined && (windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__ as () => GenericStoreEnhancer);
    const createStoreWithMiddleware = compose(
        applyMiddleware(thunk, routerMiddleware(history)),
        devToolsExtension ? devToolsExtension() : <S>(next: StoreEnhancerStoreCreator<S>) => next
    )(createStore);

    // Combine all reducers and instantiate the app-wide store instance
    const allReducers = buildRootReducer(reducers);
    const store = createStoreWithMiddleware(allReducers, initialState) as Store<ApplicationState>;

    return store;
}

function buildRootReducer(allReducers: ReducersMapObject) {
    return combineReducers<ApplicationState>(Object.assign({}, allReducers, { routing: routerReducer }));
}



// WEBPACK FOOTER //
// ./src/configureStore.ts